"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_USER_ACCOUNTS_WITH_AUTH_INFO = exports.USER_WITH_AUTH_INFO = exports.ACCOUNT_WITH_SSO_PROVIDERS = exports.GET_USER_ACCOUNTS = exports.REQUEST_MFA_RESET = exports.RESET_MFA_USER_OPTIONS = exports.VERIFY_MFA_CODE = exports.SEND_MFA_CODE = exports.USER_LOGIN = exports.ADMIN_LOGIN = void 0;
const client_1 = require("@apollo/client");
exports.ADMIN_LOGIN = (0, client_1.gql) `
  mutation AdminLogin($email: String!, $password: String!) {
    login: adminLogin(email: $email, password: $password) {
      ok
      error {
        message
        code
      }
      qrCode
      totpEnabled
    }
  }
`;
exports.USER_LOGIN = (0, client_1.gql) `
  mutation UserLogin($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      ok
      error {
        message
        code
      }
      multifactorAuthEnabled
      phoneNumberVerified
      phoneNumber
    }
  }
`;
exports.SEND_MFA_CODE = (0, client_1.gql) `
  mutation SendMFACode($data: SendMFACodeInput!) {
    sendMFACode(data: $data) {
      ok
      error {
        message
        code
      }
      multifactorAuthEnabled
      phoneNumberVerified
      phoneNumber
      retryTimeout
    }
  }
`;
exports.VERIFY_MFA_CODE = (0, client_1.gql) `
  mutation VerifyMFACode($data: VerifyMFACodeInput!) {
    verifyMFACode(data: $data) {
      ok
      error {
        message
        code
      }
      multifactorAuthEnabled
      phoneNumberVerified
      phoneNumber
    }
  }
`;
exports.RESET_MFA_USER_OPTIONS = (0, client_1.gql) `
  query GetResetMFAUserOptions($data: ResetMFAUserOptionsInput!) {
    resetMFAUserOptions(data: $data) {
      ok
      error {
        message
        code
      }
      multifactorAuthEnabled
      phoneNumberVerified
      phoneNumber
      resetUserOptions {
        id
        firstName
        lastName
      }
    }
  }
`;
exports.REQUEST_MFA_RESET = (0, client_1.gql) `
  mutation RequestMFAReset($data: RequestMFAResetInput!) {
    requestMFAReset(data: $data) {
      ok
      error {
        message
        code
      }
      multifactorAuthEnabled
      phoneNumberVerified
      phoneNumber
    }
  }
`;
exports.GET_USER_ACCOUNTS = (0, client_1.gql) `
  query GetUserAccounts($email: String!) {
    getUserAccountsByEmail(email: $email) {
      id
      logoUrl
      name
      subdomain
      isSSOEnabled
      ssoProviders {
        id
        name
        enabled
      }
    }
  }
`;
exports.ACCOUNT_WITH_SSO_PROVIDERS = (0, client_1.gql) `
  fragment AccountWithSSOProviders on Account {
    id
    logoUrl
    name
    subdomain
    isSSOEnabled
    ssoProviders {
      id
      name
      enabled
    }
  }
`;
exports.USER_WITH_AUTH_INFO = (0, client_1.gql) `
  fragment UserWithAuthInfo on UserAuthInfo {
    id
    authMethod
    ssoProviderId
    account {
      ...AccountWithSSOProviders
    }
  }
  ${exports.ACCOUNT_WITH_SSO_PROVIDERS}
`;
exports.GET_USER_ACCOUNTS_WITH_AUTH_INFO = (0, client_1.gql) `
  query GetUserAccountsWithAuthInfo($email: String!) {
    getUserAccountsWithAuthInfo(email: $email) {
      ...UserWithAuthInfo
    }
  }
  ${exports.USER_WITH_AUTH_INFO}
`;
(0, client_1.gql) `
  mutation VerifyAdminTotp($data: TotpInput!) {
    verifyAdminTotp(data: $data) {
      ok
      error {
        message
        code
      }
    }
  }
`;
(0, client_1.gql) `
  mutation ResetTotpSetup($email: String!, $password: String!) {
    resetTotpSetup(email: $email, password: $password) {
      ok
      error {
        message
        code
      }
      qrCode
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,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